<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @del="del" ref="SetBtn"></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="updateStatus('提交')" :disabled="!btn.submit">{{$t('getapi[6468]')}}</el-button>
            <el-button type="primary" size="mini" @click="updateStatus('撤回')" :disabled="!btn.retract">{{$t('getapi[6940]')}}</el-button>
            <el-button type="primary" size="mini" @click="updateStatus('审核')" :disabled="!btn.check">{{$t('getapi[941]')}}</el-button>
            <el-button type="primary" size="mini" @click="updateStatus('反审')" :disabled="!btn.recheck">{{$t('getapi[1334]')}}</el-button>
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="Fin_Payment_Due_Penalty"
                :filter_language="['order_status']"
                :filter_thousandth_puramount="['vender_amount']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
                @lct="editInfo"
        ></wTable>
        <!--<el-table :data="dataSet"
                  v-loading="loading"
                  :highlight-current-row="true"
                  show-overflow-tooltip="true"
                  border
                  stripe
                  size="mini"
                  :height="tableHeight - reduceTableHeight"
                  header-row-class-name="headerclass"
                  @selection-change="handleSelectionChange" style="width: 100%; margin-top:0px"
                  :header-cell-style="$limits.headerClass">
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2095]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_year" :label="$t('getapi[1964]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_month" :label="$t('getapi[1975]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_amount" :label="$t('getapi[7254]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_status" :label="$t('getapi[1861]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="relation_audit_period" :label="$t('getapi[7255]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[409]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[550]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[742]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[2103]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="keep_time" :label="$t('getapi[1840]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="exclusively_id" :label="$t('getapi[3359]')"></el-table-column>
            <el-table-column show-overflow-tooltip fixed="right" :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editInfo(scope)" type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[100, 200, 300, 400]" :page-size="pageSize" :pager-count="5" layout="total, sizes, prev, pager, next, jumper"
                               :total="total"></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="Fin_Payment_Due_Penalty" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6609]')" queryData="Fin_Payment_Due_Penalty" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[34]')" width="50%" :close-on-click-modal="false">
            <el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="100px" label-position="left" size="small">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[2095]')">
                                    <el-input v-model="dataDetail.order_no" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[1964]')">
                                    <el-input v-model="dataDetail.audit_year"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[1975]')">
                                    <el-input v-model="dataDetail.audit_month"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[1196]')">
                                    <el-input type="text" v-model="dataDetail.vender_code" readonly size="mini" class="mcolor">
                                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectVender()"></i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7254]')">
                                    <el-input v-model="dataDetail.vender_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[1197]')">
                                    <el-input v-model="dataDetail.vender_name" readonly></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[1861]')">
                                    <el-input v-model="dataDetail.order_status" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[7255]')">
                                    <el-input v-model="dataDetail.relation_audit_period" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[410]')">
                                    <el-input v-model="dataDetail.create_person" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[409]')">
                                    <el-input v-model="dataDetail.create_date" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[550]')">
                                    <el-input v-model="dataDetail.audit_person" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[742]')">
                                    <el-input v-model="dataDetail.audit_date" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[2103]')">
                                    <el-input v-model="dataDetail.keep_person" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[1840]')">
                                    <el-input v-model="dataDetail.keep_time" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[3359]')">
                                    <el-input v-model="dataDetail.exclusively_id" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[143]')">
                                    <el-input v-model="dataDetail.remark"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowEdit = false" size="mini">{{ $t('getapi[6]') }}</el-button>
                <el-button type="primary" @click="save" :loading="loading" :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
            </span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'FrmFPDSort/ShowVender'" @callback="getVender" ref="vender"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name: '3_fpdpenalty',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_fpdpenalty'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                selectData: [],
                btn: {
                    submit: false,
                    retract: false,
                    check: false,
                    recheck: false
                },
                isShowEdit: false,
                dataDetail: {
                    exclusively_id: null,
                    audit_year: null,
                    audit_month: null,
                    vender_code: null,
                    vender_name: null,
                    vender_amount: null,
                    order_status: null,
                    relation_invoice_no: null,
                    relation_invoice_type: null,
                    relation_audit_period: null,
                    create_person: null,
                    create_date: null,
                    audit_person: null,
                    audit_date: null,
                    order_no: null,
                    keep_person: null,
                    keep_time: null,
                    remark: null,
                    LangType: 0
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('Fin_Payment_Due_Penalty', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6609]"),this.$t("getapi[3836]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.selectData.length == 1 && that.selectData[0].order_status == '新建') {
                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,del');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                }
                that.btn.submit = false
                that.btn.retract = false
                that.btn.check = false
                that.btn.recheck = false
                console.log('选择' + JSON.stringify(that.selectData))
                if (that.selectData.length == 1) {
                    if (that.selectData[0].order_status == '新建') {
                        that.btn.submit = true
                    } else {
                        that.btn.submit = false
                    }
                    if (that.selectData[0].order_status == '提交') {
                        that.btn.retract = true
                        that.btn.check = true
                    } else {
                        that.btn.retract = false
                        that.btn.check = false
                    }
                    if (that.selectData[0].order_status == '审核') {
                        that.btn.recheck = true
                    } else {
                        that.btn.recheck = false
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_fpdpenalty',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'Fin_Payment_Due_Penalty');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/FrmFPDPenalty/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/FrmFPDPenalty/DataList/ExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "Fin_Payment_Due_Penalty",
                    fromname: that.$t('getapi[6609]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            editInfo(row) {
                let that = this
                that.isShowEdit = true
                /*let parm = {
                    Id: row.row.exclusively_id
                }
                that.$http.urlpost('/FrmFPDPenalty/ReloadData', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowEdit = true
                        that.dataDetail = res.DataContent.Head
                    }
                });*/
                let data = row.row
                that.dataDetail.exclusively_id = data.exclusively_id
                that.dataDetail.audit_year = data.audit_year
                that.dataDetail.audit_month = data.audit_month
                that.dataDetail.vender_code = data.vender_code
                that.dataDetail.vender_name = data.vender_name
                that.dataDetail.vender_amount = data.vender_amount
                that.dataDetail.order_status = data.order_status
                that.dataDetail.relation_invoice_no = data.relation_invoice_no
                that.dataDetail.relation_invoice_type = data.relation_invoice_type
                that.dataDetail.relation_audit_period = data.relation_audit_period
                that.dataDetail.create_person = data.create_person
                that.dataDetail.create_date = data.create_date
                that.dataDetail.audit_person = data.audit_person
                that.dataDetail.audit_date = data.audit_date
                that.dataDetail.order_no = data.order_no
                that.dataDetail.keep_person = data.keep_person
                that.dataDetail.keep_time = data.keep_time
                that.dataDetail.remark = data.remark
            },
            // 新增
            add() {
                let that = this;
                that.isShowEdit = true;
                that.dataDetail = {
                    exclusively_id: '',
                    audit_year: new Date().getFullYear(),
                    audit_month: new Date().getMonth() + 1,
                    vender_code: '',
                    vender_name: '',
                    vender_amount: 0,
                    order_status: '草稿',
                    relation_invoice_no: '',
                    relation_invoice_type: '',
                    relation_audit_period: '',
                    create_person: '',
                    create_date: '',
                    audit_person: '',
                    audit_date: '',
                    order_no: '',
                    keep_person: '',
                    keep_time: '',
                    remark: '',
                    LangType:0,
                };
            },
            save() {
                let that = this
                that.dataDetail.LangType=that.$processdata.getLang();
                let parm = that.dataDetail
                that.$http.urlpost('/FrmFPDPenalty/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            selectVender() {
                let that = this;
                that.$refs.vender.clearInput(true);
            },
            getVender(data) {
                let that = this
                console.log(data)
                that.dataDetail.vender_code = data.vender_code
                that.dataDetail.vender_name = data.vender_name
            },
            updateStatus(new_status) {
                console.log('-----updateStatus--', new_status);
                if (!new_status) {
                    return;
                }
                let that = this;
                if (that.selectData == null || that.selectData.length == 0) {
                    return;
                }
                
                let parm = {
                    exclusively_id: that.selectData[0].exclusively_id,
                    order_status: new_status,
                    create_date: that.selectData[0].create_date,
                    LangType: that.$processdata.getLang(),
                }

                this.$confirm(that.$t('getapi[8895]') + new_status + that.$t('getapi[6368]') +'?', that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                }).then(() => {
                    that.$http.urlpost('/FrmFPDPenalty/UpdateSatus', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getView()
                        }
                    });

                }).catch(() => {
                    this.$message({ type: 'info', message: that.$t('getapi[2448]') });//'操作失败'
                });
            },
            del() {
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        /*let arr = []
                        for(let i = 0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                exclusively_id: that.selectData[i].exclusively_id,
                                create_date: that.selectData[i].create_date,
                            }]
                        }
                        let parm = arr*/
                        let parm = {
                            exclusively_id: that.selectData[0].exclusively_id,
                            create_date: that.selectData[0].create_date
                        }
                        that.$http.urlpost('/FrmFPDPenalty/DeleteData', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;

        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
        margin-bottom: 5px !important;
    }
</style>